<template>
  <div class="tgc-mosaicv2-slim-m_flex_child">
    <article class="tge-cardv2 " :data-article-id="item.id" tge-cardv2-horizontal="medium small" tge-cardv2-crop="316x237" data-importance-factor="s">
      <a class="tge-cardv2_wrapper" :href="getLink" data-tgev="event10" data-tgev-metric="npv" data-tgev-label="(wgt_2)" data-tgev-container="mosaicv2-slim-m" data-tgev-pagename="newslocal" data-tgev-order="1">
        <div class="tge-cardv2_main">
          <div class="tge-cardv2_imgcontainer">
            <picture v-if="getImage">
              <source 
                media="(max-width: 649px)" 
                :data-srcset="getImage" 
                :srcset="getImage">
              <img 
                class="tge-cardv2_img lazyloaded" 
                :data-src="getImage" 
                width="1024" height="768" alt="Bobbin Head Garage closing" 
                :src="getImage">
            </picture>
          </div>
          <h2 class="tge-cardv2_title">
            <span v-if="isPremium" class="tge-svg-icon tge-svg-icon_premium  " data-no-canvas=""><canvas width="24" height="24"></canvas><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>premium_icon</title><g fill="none" fill-rule="evenodd"><path d="M15.975 15.955v5.972l-1.99 1.989h-5.97v-7.96h7.96z" fill="#E6007D"></path><path fill="#BA7AB3" d="M8.017 7.996h7.958v7.959H8.017z"></path><path d="M.057 15.955V9.987l1.99-1.991h5.968v7.96H.057z" fill="#C7D400"></path><path d="M23.933 7.996v5.969l-1.992 1.99h-5.969v-7.96h7.96z" fill="#F7AB00"></path><path d="M8.017 7.996v-5.97L10.004.039h5.97v7.958H8.018z" fill="#009EE3"></path></g></svg></span>
            <span>{{getTitle}}</span>
          </h2>
          <div class="tge-cardv2_standfirst">
            <span class="tge-cardv2_slug" tgs-section-color="newslocal">
              {{getKicker}} 
            </span>
            <span>{{getStandFirstContent}}</span>
          </div>
        </div>
      </a>
    </article>
  </div>
</template>

<script>
import { PRODUCT_MAP } from '../config/api.config';

export default {
  name: 'Article',
  props: {
    item: Object,
    order: Number
  },
  computed: {
    getImage() {
      const references = this.item.references || null;

      if (references) {
        const imageCapiId = Object.keys(references)[1];

        return `https://cdn.newsapi.com.au/image/v1/${imageCapiId}?width=316`;  
      } else {
        return '';
      }
    },
    getLink() {
      const productName = this.globalConfig.productName.toLowerCase();
      const targetDomain = PRODUCT_MAP[productName].targetDomain;
      
      return this.item.target.domainLink[targetDomain].link;
    },
    getTitle() {
      return this.item.headline ? this.item.headline.default : 'N/A';
    },
    getKicker() {
      return this.item.kicker ? this.item.kicker.default : 'N/A';
    },
    getStandFirstContent() {
      const regex = this.item.standfirst.default.replace(/<[^>]*>/g, '');
      
      return regex;
    },
    isPremium() {
      return this.item.accessType === 'premium' ? true : false;
    }
  }
}
</script>

<style lang="scss" scoped>
.tge-cardv2_standfirst {

  .standfirst-content {
    margin: 0;
  }
}
</style>